import store from '@/store'
import { IModalProps } from '@/store/custom-modal.module'
import { ModalType, ModalLayer } from './modal-types'

export { ModalType, ModalLayer }

export const closeOverlayAndRevealMainModals = () => {
  store.dispatch('overlayModal/closeModal')
  store.dispatch('modal/revealModal')
}

export const hideMainAndOverlyModals = () => {
  store.dispatch('overlayModal/closeModal')
  store.dispatch('modal/hideModal')
}

export const hideAndCloseMainAndOverlyModals = () => {
  store.dispatch('overlayModal/closeModal')
  store.dispatch('modal/hideModal')
  store.dispatch('modal/closeModal')
}

export const closeMainModal = () => {
  store.dispatch('modal/hideModal')
}

export const hideAndUnmountMainModal = () => {
  store.dispatch('modal/hideModal')
  store.dispatch('modal/closeModal')
}

export const initAndRevealMainModal = (modalConfig: IModalProps) => {
  store.dispatch('modal/openModal', modalConfig)
}

export const initAndRevealOverlayModal = (modalConfig: IModalProps) => {
  store.dispatch('overlayModal/openModal', modalConfig)
}
